import React from 'react';
import GptSearchBar from "./GptSearchBar";

const GptSearch = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen w-full bg-gray-100">
            <GptSearchBar />

        </div>
    );
};

export default GptSearch;
